import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from 'process';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface OrderItemOption {
  id: number;
  extras: number[];
}

export interface OrderItem {
  id: number;
  quantity: number;
  options?: OrderItemOption[];
}

export interface TermsOfService {
  accepted: 1 | 0;
  version: string;
}

export interface GuestUser {
  fName: string;
  lName: string;
  phoneNumber: string;
  userEmail: string;
  address: {
    addressLine1: string;
    addressLine2?: string;
    city: string;
    county?: string;
    country: string;
    postalCode: string;
  };
}

export interface SavedAddress {
  id: number;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  county?: string;
  country?: string;
  postalCode: string;
}

export interface InsertAddressPayload {
  action: 'insertAddress';
  foodOrderAddress: {
    addressLine1: string;
    addressLine2?: string;
    city: string;
    county?: string;
    country: string;
    postalCode: string;
  };
}

export interface OrderPayload {
  action: 'insertOrder';
  debug?: string;
  basket: {
    items: OrderItem[];
    termsOfService: TermsOfService;
    promotion: any[];
    guestUser?: GuestUser;
    address?: { deliveryId: number };
    deliveryType: 'delivery' | 'collection';
    comment?: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class OrderServiceService {
  private readonly endpoint = environment.orderUrl;

  constructor(private http: HttpClient) {}

  insertOrder(payload: OrderPayload): Observable<any> {
    return this.http.post<any>(this.endpoint, payload);
  }

  insertAddress(payload: InsertAddressPayload): Observable<any> {
    return this.http.post<any>(this.endpoint, payload);
  }

  viewAddress(): Observable<any> {
    return this.http.post<any>(this.endpoint, {
      action: 'viewAddress',
    });
  }
}
